import { FIREBASE_TOKEN_KEY, TOKEN_KEY, FIREBASE_USER } from 'utils/constants'
import { isTokenExpired } from './jwtHelper'
import jwt_decode from 'jwt-decode'

const internalUrl = window.location.href.includes('internal')

export const oidcConfig = {
  onBeforeSignIn: () => {
    if (
      (internalUrl && !process.env.POST_LOGOUT_REDIRECT_URI_INTERNAL.includes(location.pathname)) ||
      (!internalUrl && !process.env.POST_LOGOUT_REDIRECT_URI_EXTERNAL.includes(location.pathname))
    ) {
      localStorage.setItem('beforeLogin', location.href)
    }
  },
  onSignIn: async user => {
    setToken(user.id_token)
    const beforeLoginUrl = localStorage.getItem('beforeLogin')
    localStorage.removeItem('beforeLogin')
    window.location = beforeLoginUrl ? beforeLoginUrl : '/'
  },
  onSignOut: () => {
    localStorage.removeItem('beforeLogin')
  },
  authority: internalUrl ? process.env.AUTHORITY_INTERNAL : process.env.AUTHORITY_EXTERNAL,
  clientId: process.env.CLIENT_ID,
  responseType: 'code',
  redirectUri: internalUrl ? process.env.REDIRECT_URI_INTERNAL : process.env.REDIRECT_URI_EXTERNAL,
  scope: 'openid profile',
  postLogoutRedirectUri: internalUrl
    ? process.env.POST_LOGOUT_REDIRECT_URI_INTERNAL
    : process.env.POST_LOGOUT_REDIRECT_URI_EXTERNAL,
  filterProtocolClaims: true,
  loadUserInfo: true
}

export const setTokenInConfig = (token, config) => {
  if (isTokenExpired(token)) {
    // TODO: what should be done here? We shouldn't get into this situation as the oidc-client should handle this
    // but if we do, we should probably set token to null and redirect to the home page
    logout()
    token = null

    const homeUrl = (
      internalUrl ? process.env.REDIRECT_URI_INTERNAL : process.env.REDIRECT_URI_EXTERNAL
    ).replace('signin-oidc', '')
    if (window.location.href !== homeUrl) {
      window.location.href = homeUrl
    }

    console.log('token expired????????????')
  }

  if (!config.headers.Authorization) {
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
  }
}

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY)
}

const removeToken = () => {
  return localStorage.removeItem(TOKEN_KEY)
}

export const getFirebaseToken = () => localStorage.getItem(FIREBASE_TOKEN_KEY)

export const removeFirebaseToken = () => localStorage.removeItem(FIREBASE_TOKEN_KEY)

export const setFirebaseToken = token => localStorage.setItem(FIREBASE_TOKEN_KEY, token)

export const getFirebaseUser = () => localStorage.getItem(FIREBASE_USER)

export const setFirebaseUser = user => localStorage.setItem(FIREBASE_USER, user)

export const removeFirebaseUser = () => localStorage.removeItem(FIREBASE_USER)

export const isAuthenticated = () => {
  // Checks if there is a saved token and it's still valid
  const token = getToken()

  if (token) {
    return !isTokenExpired(token)
  } else {
    return false
  }
}

export const authenticate = token => {
  localStorage.setItem(TOKEN_KEY, token)
}

export const setToken = token => {
  authenticate(token)
}

export const logout = () => {
  removeToken()
  localStorage.removeItem('selectedSubdomainId')
  localStorage.removeItem('selectedStoreCode')
}

export const getUserInfo = () => {
  const token = getToken()
  try {
    return token && jwt_decode(token)
  } catch (e) {
    console.log('token is not valid')
  }
}

export const getUserRoles = () => {
  const userInfo = getUserInfo()

  return userInfo?.resource_access[process.env.CLIENT_ID]?.roles || []
}

export const getUserName = () => {
  const userInfo = getUserInfo()

  return userInfo.name
}

export const getUserTitle = () => {
  const userInfo = getUserInfo()

  return userInfo.title
}

export const getUserFirstName = () => {
  const userInfo = getUserInfo()

  return userInfo?.given_name
}

export const getUserPreferredName = () => {
  const userInfo = getUserInfo()

  return userInfo?.preferred_username
}

export const getUserAvatarString = () => {
  const userName = getUserName()

  if (userName) {
    return userName
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
  }

  return ''
}

export const getUserStore = () => {
  const userInfo = getUserInfo()

  return userInfo.store_name || ''
}

export const getUserStoreInfo = () => {
  const userInfo = getUserInfo()
  const storeInfo = userInfo.domain_name
    ? userInfo.domain_name.split(',').find(attr => attr.includes('OU=STORE'))
    : ''

  if (!storeInfo) {
    return {}
  }

  const result = storeInfo.replace('OU=STORE', '').split('-')

  return { storeADId: result[0].trim(), storeName: result[1].trim() }
}

export const getUserRegion = () => {
  const userInfo = getUserInfo()

  return userInfo.region_name || ''
}
